import { render } from "./Invite.vue?vue&type=template&id=1940e398&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&id=1940e398&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-1940e398"

export default script